export enum Inputs {
  USERNAME_CONTAINER = 'username-input-container',
  PASSWORD_CONTAINER = 'password-input-container',
}

export enum Forms {
  RESET_2FA = 'reset-2fa-form',
}
